import { render, staticRenderFns } from "./RootContrattiAttiviView.vue?vue&type=template&id=2fd9d19a&"
import script from "./RootContrattiAttiviView.vue?vue&type=script&lang=ts&"
export * from "./RootContrattiAttiviView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports